// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"4deddd28","163":"45dfeae3","270":"a8b02ff8","434":"15091f2d","514":"746c00fd","787":"ba4a8c28"}[chunkId] + ".chunk.js";
};